import moment from 'moment';

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DISPLAYED_DATE_FORMAT = 'DD-MMM-YYYY';

export const addDaysToDate = (date, days) =>
  moment(date).add(days, 'days').toDate();

export const subtractDaysToDate = (date, days) =>
  moment(date).subtract(days, 'days').toDate();

export const formatDate = newDate => moment(newDate).format(DATE_FORMAT);

export const formatDisplayDate = displayDate => {
  const date = moment(displayDate);
  if (!date.isValid()) {
    return '';
  }
  return date.format(DISPLAYED_DATE_FORMAT);
};

export const formatDatesToLocale = () => {
  const currentLocale = moment.locale(); // read current locale
  if (currentLocale) {
    switch (currentLocale) {
      case 'en':
        return 'Do MMMM';
      case 'es':
        return 'D MMMM';
      default:
        return 'D MMMM';
    }
  }
  return 'D MMMM';
};
